<template>
    <div class="h-screen flex justify-center items-center text-gray-900">
        <div class="w-full max-w-md mx-auto p-4">

            <h1 class="text-2xl mb-8">Reset your password</h1>

            <form class="space-y-6" @submit.prevent="onSubmit">

                <InputBasic
                    :disabled="true"
                    label="Email"
                    name="email"
                    placeholder="Please enter your email..."/>

                <InputBasic
                    label="New Password"
                    name="password"
                    placeholder="Please enter your password..."
                    type="password"/>

                <InputBasic
                    label="Confirm New Password"
                    name="password_confirmation"
                    placeholder="Please confirm your password..."
                    type="password"/>

                <SubmitButton
                    :class="{'hover:bg-blue-100 hover:text-blue-700 active:text-blue-900': !form.errors.any()}"
                    :disabled="form.errors.any()"
                    :submitting="form.processing"
                    class="w-full text-blue-600 text-sm py-2 px-4 border border-blue-500 rounded">
                    Reset password
                </SubmitButton>
            </form>
        </div>
    </div>
</template>

<script>

import Form from "form-backend-validation"
import InputBasic from "@app/Shared/Components/InputBasic";
import SubmitButton from "@app/Shared/Components/SubmitButton";

export default {

    props: {
        email: String,
        token: String
    },

    data() {
        return {
            form: new Form({
                token: this.token,
                email: this.email,
                password: '',
                password_confirmation: ''
            }, {resetOnSuccess: false})
        }
    },

    components: {
        InputBasic,
        SubmitButton
    },

    methods: {
        onSubmit() {

            if (this.form.processing) {
                return;
            }

            this.form.post('/password/reset')
                .then(response => {
                    window.location.href = "/admin";
                })
                .catch()
        }
    }
};
</script>
